import { FunnelIcon } from "lucide-react";

import { cn } from "@/libs/cn";

interface FilterButtonProps {
  appliedCount: number;
  onClick: () => void;
  className?: string;
}

const FilterButton = ({ appliedCount, onClick, className }: FilterButtonProps) => {
  const isActive = appliedCount > 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "relative flex items-center justify-center cursor-pointer h-10 w-10 rounded-lg border bg-white shrink-0 hover:bg-ui-hover transition-colors disabled:cursor-not-allowed",
        isActive ? "border-ui-primary text-ui-primary border-2" : "border-ui-border-muted text-ui-text-muted",
        className,
      )}
    >
      <FunnelIcon fill={isActive ? "var(--color-ui-primary)" : "none"} className="size-5" />

      {isActive && (
        <span className="absolute -top-1.5 -right-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-ui-primary px-1 text-[10px] font-medium text-white">
          {appliedCount}
        </span>
      )}
    </button>
  );
};

export default FilterButton;
